// 型変換関連

// 3桁区切り数値変換
export function convert1000Separator(val) {
    if (val == '') return '';
    if (isNaN(val)) return val;
    return Number(val).toLocaleString(undefined, { maximumFractionDigits: 20 });
}

// 金額表示に変換する
export function convertPrice(val) {
    if (val == '') return '';
    if (isNaN(val)) return val;
    return '¥' + convert1000Separator(val);
}

// 金額表示(テキスト除除外)に変換する
export function convertPriceNotText(val) {
    if (val == '' || isNaN(val)) return '';
    return '¥' + convert1000Separator(val);
}

// 時間単位付表示に変換する
export function convertHour(val) {
    if (val == '') return '';
    if (isNaN(val)) return val;
    return String(val) + 'h';
}

// パーセント表示に変換する
export function convertPercentage(val) {
    if (val == '') return '';
    if (isNaN(val)) return val;
    return val + '%';
}

// 単位記号などを取り除き、数値(単位記号など以外の)文字列に変換する
export function convertNum(val) {
    return String(val).replace(/\¥|,|h/g, '');
}

// 電話番号の"-"(ハイフン)を取り除き、数値文字列に変換する
export function convertPhoneNum(val) {
    if (val == '') return '';
    return String(val).replace(/-/g, '');
}

// 全データの単位付加
export function convertAllInputData() {
    // ページ表示時のデータ変換
    $('.js-data-price').each(function(i, e) {
        $(e).val(convertPrice($(e).val()));
    });
    $('.js-data-hour').each(function(i, e) {
        $(e).val(convertHour($(e).val()));
    });
    $('.js-data-percentage').each(function(i, e) {
        $(e).val(convertPercentage($(e).val()));
    });
    $('.js-data-1000sep').each(function(i, e) {
        $(e).val(convert1000Separator($(e).val()));
    });
}

// 全データの単位除去
export function convertNumAllInputData() {
    // ページ表示時のデータ変換
    $('.js-data-price').each(function(i, e) {
        $(e).val(convertNum($(e).val()));
    });
    $('.js-data-hour').each(function(i, e) {
        $(e).val(convertNum($(e).val()));
    });
    $('.js-data-percentage').each(function(i, e) {
        $(e).val(convertNum($(e).val()));
    });
    $('.js-data-1000sep').each(function(i, e) {
        $(e).val(convertNum($(e).val()));
    });
}
